import React, { Component } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";


import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import EqualizerOutlinedIcon from "@mui/icons-material/EqualizerOutlined";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";


//import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import DashboardHeader from "./DashboardHeader";
import SummaryCard from "../../components/dashlibs/SummaryCard";
import SectionCard from "../../components/dashlibs/SectionCard";
import StatusBadge from "../../components/dashlibs/StatusBadge";
import AlertList from "../../components/dashlibs/AlertList";
import { MockBarChart, MockTrendChart } from "../../components/dashlibs/MockChart";
import { DashboardPageProps } from "./dashboard.types";

import type { ChartTone } from "../../components/charts";
import { DonutChart, AreaTrendChart, BarChart, TreemapChart, BulletChart, BubbleChart } from "../../components/charts";

const projectCompletion = [
  { label: "Sécurisation incendie Bingo", value: 68, color: "#116B43" },
  { label: "Réhabilitation Bobo", value: 44, color: "#163A5F" },
  { label: "Modernisation SI", value: 52, color: "#2471A3" },
  { label: "Renforcement dépôt", value: 37, color: "#D68910" },
];

const projectCostPressure = [
  { label: "Incendie Bingo", value: 61, color: "#C0392B" },
  { label: "Réhabilitation Bobo", value: 53, color: "#D68910" },
  { label: "Modernisation SI", value: 41, color: "#163A5F" },
  { label: "Sécurité périmétrique", value: 58, color: "#A93226" },
];

const investmentTrend = [26, 31, 33, 39, 45, 47, 51, 56, 59, 63, 66, 69];

const projectAlerts = [
  {
    title: "Réhabilitation Bobo en retard",
    description: "Le projet présente un retard d’avancement par rapport au calendrier prévu.",
    tone: "warning" as const,
  },
  {
    title: "Coût en hausse sur sécurisation incendie Bingo",
    description: "Une pression de coût est observée sur certains lots du projet.",
    tone: "danger" as const,
  },
  {
    title: "Modernisation SI sous contrôle",
    description: "Le projet reste globalement cohérent avec les objectifs de coûts et délais.",
    tone: "success" as const,
  },
];

const projectGovernance = [
  { label: "Taux d’avancement moyen", value: 55, color: "#116B43" },
  { label: "Respect du budget", value: 48, color: "#163A5F" },
  { label: "Respect des délais", value: 42, color: "#D68910" },
  { label: "Alignement stratégique", value: 63, color: "#2471A3" },
];

export default class ProjectsDashboard extends Component<DashboardPageProps,any> {

  render(){
  const {userData,dashData,sharedFilters,filterOptions,onFilterChange,onRefresh} = this.props;
  const {meta,sections={},summaryCards=[]} = dashData || {};

  const {projectProgress={},projectByCostCenter={},capexByAccount={},projectAlerts={},projectPortfolio={}} = sections;

  const iconMap: any = {
    projects: <TrackChangesOutlinedIcon />,
    track: <TrackChangesOutlinedIcon />,
    investment: <BusinessCenterOutlinedIcon />,
    equalizer: <EqualizerOutlinedIcon />,
    warning: <WarningAmberOutlinedIcon />,
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: "grid", gap: 2.5 }}>
      <DashboardHeader
        title="Dashboard Projets & Investissements"
        subtitle="Vue consolidée des investissements, des projets en portefeuille, des coûts, des délais et des risques de réalisation."
        userData={userData}
        sharedFilters={sharedFilters}
        filterOptions={filterOptions}
        onFilterChange={onFilterChange}
        onRefresh={onRefresh}
      />

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 2 }}>
        {(summaryCards || []).map((card: any) => (
        <SummaryCard
          key={card.code}
          title={card.label}
          value={card.valueFormatted}
          subtitle={card.subtitle}
          delta={card.deltaFormatted}
          tone={card.tone}
          icon={iconMap[card.icon] || <AccountBalanceWalletOutlinedIcon />}
        />
        ))}
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr" }}>
        <SectionCard
          title={projectProgress.title || ""}
          subtitle={projectProgress.subtitle || ""}
        >
          <BulletChart data={(projectProgress.data || [])} />
        </SectionCard>
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" } }}>
        <Box sx={{overflowX: "auto", pt: 0.5 }}>
        <SectionCard
          title={projectByCostCenter.title || ""}
          subtitle={projectByCostCenter.subtitle || ""}
        >
          <BarChart data={projectByCostCenter.data || []} />
        </SectionCard>
        </Box>
        
        <SectionCard
          title={capexByAccount.title || ""}
          subtitle={capexByAccount.subtitle || ""}
        >
          <BulletChart data={(capexByAccount.data || [])} />
        </SectionCard>
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" } }}>
        <SectionCard
          title={projectAlerts.title || ""}
          subtitle={projectAlerts.subtitle || ""}
        >
          <Box sx={{ maxHeight: 360, overflowY: "auto", pr: 0.5 }}>
            <AlertList items={projectAlerts.data || []} />
          </Box>
        </SectionCard>

        <SectionCard
          title={projectPortfolio.title || "Vue portefeuille"}
          subtitle={projectPortfolio.subtitle || "Synthèse simple des critères de pilotage des projets"}
        >
          <BubbleChart xName="Risk" yName="ROI" data={(projectPortfolio.data || [])} />
        </SectionCard>
      </Box>

{/* 
      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(6, 1fr)",
          },
        }}
      >
        <SummaryCard
          title="Projets actifs"
          value="12"
          subtitle="Portefeuille en cours"
          delta="FY2025"
          tone="info"
          icon={<BusinessCenterOutlinedIcon />}
        />
        <SummaryCard
          title="Investissement engagé"
          value="8,6 Md"
          subtitle="CAPEX cumulé"
          delta="12,3%"
          tone="default"
          icon={<PaidOutlinedIcon />}
        />
        <SummaryCard
          title="Avancement moyen"
          value="55%"
          subtitle="Tous projets"
          delta="+4 pts"
          tone="success"
          icon={<EngineeringOutlinedIcon />}
        />
        <SummaryCard
          title="Délais à risque"
          value="4"
          subtitle="Projets sensibles"
          delta="2 critiques"
          tone="warning"
          icon={<ScheduleOutlinedIcon />}
        />
        <SummaryCard
          title="Pression coût"
          value="3"
          subtitle="Sous surveillance"
          delta="Haut impact"
          tone="danger"
          icon={<WarningAmberOutlinedIcon />}
        />
        <SummaryCard
          title="Alignement"
          value="63%"
          subtitle="Valeur stratégique"
          delta="En progression"
          tone="info"
          icon={<TrackChangesOutlinedIcon />}
        />
      </Box>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 8 }}>
          <SectionCard
            title="Tendance d’investissement"
            subtitle="Évolution globale de l’exécution et de l’avancement des projets."
            action={<StatusBadge label="CAPEX" tone="info" />}
          >
            <MockTrendChart points={investmentTrend} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Alertes projets"
            subtitle="Points nécessitant pilotage ou arbitrage."
          >
            <AlertList items={projectAlerts} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Avancement par projet"
            subtitle="Lecture simplifiée du niveau d’achèvement des principaux projets."
          >
            <MockBarChart data={projectCompletion} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Pression coût par projet"
            subtitle="Projets présentant les risques de dépassement les plus marqués."
            action={<StatusBadge label="Cost risk" tone="warning" />}
          >
            <MockBarChart data={projectCostPressure} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Gouvernance portefeuille"
            subtitle="Lecture synthétique de la maîtrise du portefeuille projets."
          >
            <MockBarChart data={projectGovernance} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Lecture management"
            subtitle="Messages à retenir sur les investissements et la conduite des projets."
          >
            <Stack spacing={1.25}>
              {[
                ["Le portefeuille reste actif mais hétérogène", "Les projets n’avancent pas au même rythme et nécessitent des arbitrages différenciés."],
                ["Les délais sont un enjeu clé", "Le principal risque observé concerne les glissements de calendrier sur certains projets d’infrastructure."],
                ["L’alignement stratégique doit rester visible", "Les investissements doivent être suivis à la fois sur les coûts, les délais et la valeur stratégique produite."],
              ].map(([title, desc]) => (
                <Box
                  key={title}
                  sx={{
                    p: 1.5,
                    borderRadius: "10px",
                    border: "1px solid #E2E8EE",
                    bgcolor: "#FFFFFF",
                  }}
                >
                  <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#17324D" }}>
                    {title}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#66788A", mt: 0.5, lineHeight: 1.65 }}>
                    {desc}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Vue portefeuille"
            subtitle="Synthèse simple des critères de pilotage des projets."
          >
            <Stack spacing={1.5}>
              {[
                ["Projet le plus avancé", "Sécurisation incendie Bingo", "success"],
                ["Projet le plus exposé", "Réhabilitation Bobo", "warning"],
                ["Risque principal", "Glissement calendrier", "danger"],
                ["Lecture globale", "Portefeuille à piloter activement", "info"],
              ].map(([label, value, tone]) => (
                <Stack
                  key={label}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{
                    p: 1.25,
                    borderRadius: "10px",
                    bgcolor: "#F8FAFB",
                    border: "1px solid #E2E8EE",
                  }}
                >
                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#33495C" }}>
                    {label}
                  </Typography>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography sx={{ fontSize: 13, color: "#17324D", fontWeight: 800 }}>
                      {value}
                    </Typography>
                    <StatusBadge label={String(tone).toUpperCase()} tone={tone as any} />
                  </Stack>
                </Stack>
              ))}
            </Stack>
          </SectionCard>
        </Grid>
      </Grid> */}
    </Box>
  );
}
}
